import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2f346f30"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "frisbuy-pagination-panel" }
const _hoisted_2 = { class: "frisbuy-pagination-panel__pages" }
const _hoisted_3 = ["onClick"]

import { computed, nextTick, onBeforeUnmount, onMounted, ref } from "vue";
import ArrowButton from "../ArrowButton.vue";
import ButtonHiddenPages from "./ButtonHiddenPages.vue";

const minVisiblePagesCount = 3;
const constantlyVisiblePagesCount = 2; // NOTE: First and Last page constantly visible

export default /*#__PURE__*/_defineComponent({
  __name: 'PaginationPanel',
  props: {
  countOfPages: {
    type: Number,
    required: true,
    validator: (val: number) => val > 0,
  },

  maxVisiblePages: {
    type: Number,
    required: false,
    default: 8,
    validator: (val: number) => val > 0,
  },

  selectedPage: {
    type: Number,
    required: true,
    validator: (val: number) => val >= 1,
  },
},
  emits: ["selectPage"],
  setup(__props, { emit: __emit }) {

const props = __props;

const emit = __emit;

const isFirstPage = computed(() => {
  return props.selectedPage === 1;
});
const isLastPage = computed(() => {
  return props.selectedPage === props.countOfPages;
});

function selectPage(page: number) {
  let pageForEmit = page;

  if (pageForEmit < 1) {
    pageForEmit = 1;
  } else if (pageForEmit > props.countOfPages) {
    pageForEmit = props.countOfPages;
  }

  if (pageForEmit === props.selectedPage) {
    return;
  }

  emit("selectPage", pageForEmit);
}

//#region Adaptive pages count
const visiblePagesCount = ref<number>(props.maxVisiblePages);
const paginationPanelInner = ref<HTMLElement>();

onMounted(() => {
  recompileVisiblePagesCount();
  window.addEventListener("resize", recompileVisiblePagesCount);
});
onBeforeUnmount(() => {
  window.removeEventListener("resize", recompileVisiblePagesCount);
});

async function recompileVisiblePagesCount() {
  await nextTick();
  const scrollWidth = 45;
  const windowWidth = window.innerWidth - scrollWidth;

  if (
    paginationPanelInner.value &&
    paginationPanelInner.value.offsetWidth > windowWidth &&
    visiblePagesCount.value > minVisiblePagesCount + 1
  ) {
    visiblePagesCount.value -= 1;
    recompileVisiblePagesCount();
  } else if (
    paginationPanelInner.value &&
    paginationPanelInner.value.offsetWidth < windowWidth &&
    visiblePagesCount.value <= props.maxVisiblePages
  ) {
    visiblePagesCount.value += 1;
    // recompileVisiblePagesCount();
  }
}
//#endregion Adaptive pages count

const visiblePages = computed<Array<number>>(() => {
  const pages = [];

  for (let i = minVisiblePage.value; i <= maxVisiblePage.value; i++) {
    if (getPageVisibility(i)) {
      pages.push(i);
    }
  }

  return pages;
});

const minVisiblePage = computed(() => {
  return Math.ceil(
    props.selectedPage -
      (visiblePagesCount.value - constantlyVisiblePagesCount) / 2
  );
});
const maxVisiblePage = computed(() => {
  return minVisiblePage.value > 0
    ? minVisiblePage.value +
        visiblePagesCount.value -
        constantlyVisiblePagesCount
    : visiblePagesCount.value + 1; // NOTE: 1 - first page
});

function getPageVisibility(page: number) {
  if (page <= 0 || page > props.countOfPages) {
    return false;
    // throw new Error(`Wrong page (${page}). 0 < ${page} <= countOfPages`);
  }

  const isVisible =
    page <= maxVisiblePage.value && page >= minVisiblePage.value;

  const isFirstPage = page === 1;
  const isLastPage = page === props.countOfPages;

  return isVisible && !isFirstPage && !isLastPage;
}

const isVisibleLeftButtonHiddenPages = computed(() => {
  const isVisible =
    minVisiblePage.value > 2 ? getPageVisibility(minVisiblePage.value) : false;

  return isVisible;
});
const isVisibleRightButtonHiddenPages = computed(() => {
  const isVisible = maxVisiblePage.value < props.countOfPages;

  return isVisible;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "frisbuy-pagination-panel__inner",
      ref_key: "paginationPanelInner",
      ref: paginationPanelInner
    }, [
      _createVNode(ArrowButton, {
        customClass: "frisbuy-pagination-panel__arrow",
        direction: "left",
        fillColor: "#303133",
        fillColorDisabled: "#C0C4CC",
        isDisabled: isFirstPage.value,
        onClick: _cache[0] || (_cache[0] = () => selectPage(props.selectedPage - 1))
      }, null, 8, ["isDisabled"]),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("button", {
          class: _normalizeClass(["frisbuy-pagination-panel__page", { '--selected': 1 === props.selectedPage }]),
          onClick: _cache[1] || (_cache[1] = () => selectPage(1))
        }, " 1 ", 2),
        (isVisibleLeftButtonHiddenPages.value)
          ? (_openBlock(), _createBlock(ButtonHiddenPages, {
              key: 0,
              class: "frisbuy-pagination-panel__page",
              direction: "left",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (
            selectPage(
              props.selectedPage -
                (visiblePagesCount.value - constantlyVisiblePagesCount)
            )
          ))
            }))
          : _createCommentVNode("", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(visiblePages.value, (page) => {
          return (_openBlock(), _createElementBlock("button", {
            key: page,
            class: _normalizeClass(["frisbuy-pagination-panel__page", { '--selected': page === props.selectedPage }]),
            onClick: () => selectPage(page)
          }, _toDisplayString(page), 11, _hoisted_3))
        }), 128)),
        (isVisibleRightButtonHiddenPages.value)
          ? (_openBlock(), _createBlock(ButtonHiddenPages, {
              key: 1,
              class: "frisbuy-pagination-panel__page",
              direction: "right",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (
            selectPage(
              props.selectedPage +
                (visiblePagesCount.value - constantlyVisiblePagesCount)
            )
          ))
            }))
          : _createCommentVNode("", true),
        (props.countOfPages > 1)
          ? (_openBlock(), _createElementBlock("button", {
              key: 2,
              class: _normalizeClass(["frisbuy-pagination-panel__page", { '--selected': props.countOfPages === props.selectedPage }]),
              onClick: _cache[4] || (_cache[4] = () => selectPage(props.countOfPages))
            }, _toDisplayString(props.countOfPages), 3))
          : _createCommentVNode("", true)
      ]),
      _createVNode(ArrowButton, {
        customClass: "frisbuy-pagination-panel__arrow",
        direction: "right",
        fillColor: "#303133",
        fillColorDisabled: "#C0C4CC",
        isDisabled: isLastPage.value,
        onClick: _cache[5] || (_cache[5] = () => selectPage(props.selectedPage + 1))
      }, null, 8, ["isDisabled"])
    ], 512)
  ]))
}
}

})